@let moderatorView = getModeratorView(poll);

<div class="poll-header">
	<p class="poll-question">{{ poll.question }}</p>
	@if (poll.canBeEdited || poll.canBeDeleted) {
		<div dropdown vbDropdown class="menu-wrapper">
			<button dropdownToggle class="icon-btn" [attr.aria-label]="'Event_PollManageMenuButton' | translate" [id]="'pollsCardMenuBtn' + cardIndex" [attr.aria-controls]="'pollsCardMenu' + cardIndex">
				<span class="dot"></span><span class="dot"></span><span class="dot"></span>
			</button>
			<div *dropdownMenu class="dropdown dropdown-menu dropdown-menu-right" role="menu" [id]="'pollsCardMenu' + cardIndex" [attr.aria-labelledby]="'pollsCardMenuBtn' + cardIndex">
				<button role="menuitem" class="dropdown-item" [hidden]="!poll.canBeEdited" (click)="pollEdited.emit()">
					{{ 'Edit' | translate }}
				</button>
				<button role="menuitem" class="dropdown-item" [hidden]="!poll.canBeDeleted" (click)="pollDeleted.emit()">
					{{ 'Delete' | translate }}
				</button>
			</div>
		</div>
	}
</div>

@if (!poll.multipleChoice) {
	<div class="view-toggles">
		<button type="button" class="toggle-btn" [class.active]="moderatorView === PollGraphType.BAR" (click)="setBarGraph()" [attr.aria-label]="'Event_PollBarGraph' | translate" [title]="'Event_PollBarGraph' | translate">
			<span class="vb-icon vb-icon-barchart-horizontal-nofill"></span>
		</button>
		<button type="button" class="toggle-btn" [class.active]="moderatorView === PollGraphType.PIE" (click)="setPieGraph()" [attr.aria-label]="'Event_PollPieChart' | translate" [title]="'Event_PollPieChart' | translate">
			<span class="vb-icon vb-icon-piechart-nofill"></span>
		</button>
	</div>
}

@if (moderatorView === PollGraphType.BAR) {
	<div class="poll-options">
		<div *ngFor="let answer of poll.answers" class="option-bar">
			<div class="fill-bar" [style.width]="getPercent(answer)"></div>
			<span class="option-label">{{ answer.text }}</span>
			<span class="option-stat">
				{{ getPercent(answer) }} ({{ answer.count }})
			</span>
		</div>
	</div>
} @else if (moderatorView === PollGraphType.PIE) {
	@if (poll.totalResponses > 0) {
	<vb-ui-pie-chart flex="fill" class="pie-chart" categoryField="text" [disableLegendToggle]="true" [internalLabels]="true" [updateEnabled]="true" [data]="poll.answers" [bottomLegend]="true" [scrollableLegend]="true" [outline]="true" valueField="count" [legendCssClass]="'legend-output'">
	</vb-ui-pie-chart>
	} @else {
		<span class="d-flex justify-content-center">{{ 'UI_Chart_NoDataAvailable' | translate }}</span>
	}
}

<div class="poll-footer">
	<div class="poll-response-footer">
		<span class="responses" [ngPlural]="poll.totalResponses">
			<ng-template ngPluralCase="=1">
				{{ 'Event_PollResponseCount_1' | translate: { '0': 1 } }}
			</ng-template>
			<ng-template ngPluralCase="other">
				{{ 'Event_PollResponseCount_n' | translate: { '0': !poll.totalResponses ? 0 : poll.totalResponses } }}
			</ng-template>
		</span>
		<span class="meta">
			{{ ('Event_MultipleChoiceLabel' | translate ) }} &nbsp;
			{{ (poll.multipleChoice ? 'Yes' : 'No') | translate }}
		</span>
	</div>
	<div class="poll-publish-footer">
		<div class="d-flex align-items-center gap-1">
			<vb-toggle-button [name]="'openPoll' + cardIndex" [toggleId]="'openPoll' + cardIndex" [ariaLabel]="('Event_OpenPoll_AriaLabel' | translate: { '0': poll.question })" [ngModel]="poll.isOpen" (ngModelChange)="poll.isOpen ? poll.close() : poll.open()">
			</vb-toggle-button>
			<span>{{ 'Event_OpenPoll' | translate }}</span>
			<vb-ui-tooltip class="margin-left-10" [iconName]="'circle_question_mark'" [placement]="'top'" [text]="'Event_OpenPoll_HelpText' | translate">
			</vb-ui-tooltip>
		</div>
		<div>
			<button type="button" [hidden]="!poll.isClosed" (click)="poll.publish()" vbBtnPrimary>
				{{ 'Event_PublishResults' | translate }}
			</button>
			<button type="button" [hidden]="!poll.isPublished" (click)="poll.unpublish()" vbBtnPrimary>
				{{ 'Event_HideResults' | translate }}
			</button>
		</div>
	</div>
</div>
